import { circle } from '@turf/circle';
import distance from '@turf/distance';
import { pointsWithinPolygon } from '@turf/points-within-polygon';
import type { FeatureCollection, Point, Polygon } from 'geojson';
import * as React from 'react';
import type { Camera, NearByCamerasByCameraProps, NearByCamerasByCameraState } from './Cameras.types';
import { NearbyCameras } from './NearbyCameras';

export class NearByCamerasByCamera extends React.Component<NearByCamerasByCameraProps, NearByCamerasByCameraState> {
    private currentCamera: Camera;

    constructor(props: NearByCamerasByCameraProps) {
        super(props);

        this.currentCamera = props.cameras.filter((c) => {
            return c.pageId === props.currentCameraPageId;
        })[0];

        this.state = { closeCameras: [] };
    }

    public componentDidMount(): void {
        const closeCameras = this.getCloseCameras(this.currentCamera);
        this.setState({ closeCameras });
    }

    public render(): JSX.Element {
        return (
            <NearbyCameras
                cameras={this.state.closeCameras}
                region={this.props.region}
                currentArea={this.props.currentArea}
                currentRoad={this.props.currentRoad}
                noImageUrl={this.props.noImageUrl}
            />
        );
    }

    private getCloseCameras(currentCamera: Camera): Camera[] {
        const points = {
            type: 'FeatureCollection',
            features: this.props.cameras.map((c) => {
                return {
                    type: 'Feature',
                    id: c.cameraId,
                    properties: c,
                    geometry: c.wgs84Position,
                };
            }),
        } as FeatureCollection<Point, Camera>;

        const searchWithin = {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: circle(currentCamera.wgs84Position, 20).geometry.coordinates,
                    },
                },
            ],
        } as FeatureCollection<Polygon>;

        const nearbyCameras = pointsWithinPolygon(points, searchWithin)
            .features.map((camera) => {
                camera.properties['distance'] = distance(currentCamera.wgs84Position, camera as unknown as Point);
                return camera;
            })
            .filter((c) => c.id !== currentCamera.cameraId)
            .sort((a, b) => {
                const x = a.properties['distance'];
                const y = b.properties['distance'];
                return x < y ? -1 : x > y ? 1 : 0;
            })
            .slice(0, 6)
            .map((camera) => {
                return camera.properties;
            });

        return nearbyCameras.filter((camera) => {
            return camera.pageId !== this.currentCamera.pageId;
        });
    }
}
